import React, { Component } from 'react';
import { Chart } from 'primereact/chart';

class RadarChart extends Component {
    constructor(props) {
        super(props);
        var data = JSON.parse(this.props.values);

        this.state = {
            data: data
        };
    }

    render() {
        const basicOptions =  {
            legend: {
                labels: {
                    fontColor: '#495057'
                }
            },
            scale: {
                pointLabels: {
                    fontColor: '#495057'
                },
                gridLines: {
                    color: '#ebedef'
                }
            }
        };

        return (
            <div className="card">
                <Chart type="radar" data={this.state.data} options={basicOptions} />
            </div>
        )
    }
}

export default RadarChart;